// extracted by mini-css-extract-plugin
export default {"tab":"Settings_tab__8jqaz"};